import React from "react";
import AdultLogoLight from "../../../assets/images/rosehealth.svg";
import YouthLogoLight from "../../../assets/images/youth_logo_light.svg";

export const ClinicPin = ({ pin = "0000" }) => {
  return (
    <div className="container-fluid w-100 text-center text-white">
      <h5 style={{ fontWeight: "500" }}>Verification Code</h5>
      <div className="code-pill mx-auto">{pin}</div>
    </div>
  );
};

export const SidebarLogo = () => {
  return (
    <div
      className="container-fluid text-center"
      style={{
        marginTop:
          process.env.REACT_APP_DASHBOARD_TYPE === "adult" ? "25%" : "5%",
        marginBottom: "12%",
      }}
    >
      {process.env.REACT_APP_DASHBOARD_TYPE === "adult" ? (
        <img
          src={AdultLogoLight}
          height="60px"
          width="100%"
          alt="Rose Health"
        />
      ) : (
        <img
          src={YouthLogoLight}
          height="150px"
          width="50%"
          alt="Rose Health"
        />
      )}
    </div>
  );
};
